import React from "react";
import { notification } from "antd";
import { StopOutlined } from "@ant-design/icons";

//type: any, desc:  string, duration: number = 5
export const Notification = (config: any): any => {
    if (config.type === "error") {
        (notification as any)[config.type]({
            key: config.id ? config.title : "",
            message: config.title,
            description: config.message,
            placement: "bottomLeft",
            className: "ant-notification-bottomLeft",
            icon: <StopOutlined style={{ color: "#DE2E21" }} translate="yes" onClick={() => closeNotification(config.Id)} />,
            duration: config.duration || 0,
        });
    } else {
        (notification as any)[config.type]({
            key: config.id ? config.title : "",
            message: config.title,
            description: config.message,
            placement: "bottomLeft",
            className: "ant-notification-bottomLeft",
            duration: config.duration || 0,
        });
    }
    setTimeout(() => {
        const elements = document.getElementsByClassName("ant-notification-notice-close");
        if (elements.length > 0) {
            const firstElement = elements[0];
            firstElement.setAttribute("role", "button");
        }
        const spans = document.getElementsByClassName('ant-notification-notice-close-icon');
        for (let span of spans) {
            const svgs = span.getElementsByTagName('svg');
            for (let svg of svgs) {
                svg.setAttribute('aria-label', 'close');
            }
        }
    }, 1000);

    const closeNotification = (key: string) => notification.close(key);
};
